import {Component} from "@angular/core";
import {IdentityModel, LoginStatus} from "../identity/identity.model";
import {SessionModel} from "../orchestration/session.model";
import {AnalyticsService} from "../orchestration/analytics.service";
import {AppModuleConstants} from "../app.module.constants";
import {Local} from "../config-support/config";
import {LocalConfigurationService} from "@fedelta-pos/data-client";
import {ResponsiveService} from "../orchestration/responsive.service";
import {ButtonConnotation, ButtonProminence} from "../buttons/button/button";
import {NavigationService} from "../orchestration/navigation.service";
import {Page} from "../orchestration/page";
import {IdentificationMode} from "../identity/identification-page/identification-mode";
import {IconButtonType} from "../buttons/icon-button/icon-button";
import {OrderingContextModel} from "../ordering-context/ordering-context.model";
import {DateTime} from "../string-utils/date-time";
import {CustomerDetails, CustomerDetailsService} from "../customer-info/customer-details.service";

@Component({
    selector: "woa-nav-menu-page",
    templateUrl: "./nav-menu-page.component.html",
    providers: [{provide: Page, useExisting: NavMenuPageComponent}]
})
export class NavMenuPageComponent extends Page {
    ButtonProminence = ButtonProminence;
    ButtonConnotation = ButtonConnotation;
    IconButtonType = IconButtonType;
    DateTime = DateTime;

    version: string;
    customerDetails: CustomerDetails;

    constructor(public sessionModel: SessionModel,
                public orderingContextModel: OrderingContextModel,
                public identityModel: IdentityModel,
                private navigationService: NavigationService,
                private responsiveService: ResponsiveService,
                private localConfigurationService: LocalConfigurationService,
                private analyticsService: AnalyticsService,
                customerDetailsService: CustomerDetailsService) {
        super();
        this.version = AppModuleConstants.VERSION;
        this.customerDetails = customerDetailsService.loadCustomer();
        (async () => {
            const platformVersion: string = await this.localConfigurationService.getString(Local.PLATFORM_VERSION);
            if (platformVersion) {
                this.version = this.version + " : " + platformVersion;
            }
        })();
    }

    get profileName(): string {
        return !this.identityModel.isGuestUser && this.identityModel.currentIdentity.firstName ? this.identityModel.currentIdentity.firstName :
            this.customerDetails ? this.customerDetails.firstName
                : undefined;
    }

    get currentStoreLabel(): string {
        return this.orderingContextModel.canChangeStore ? "woa.label.nav-menu.current-store" : "woa.label.nav-menu.single-store";
    }

    get showFeedback(): boolean {
        return this.sessionModel.currentApp && this.sessionModel.currentApp.feedbackCategories.length > 0;
    }

    get showRateApp(): boolean {
        return this.sessionModel.currentApp && this.sessionModel.currentApp.showRateApp && (this.responsiveService.isApp);
    }

    dismiss(): void {
        // noinspection JSIgnoredPromiseFromCall
        this.navigationService.dismissPage(this);
    }

    async login(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("login");
        // noinspection ES6MissingAwait
        this.navigationService.dismissPage(this);
        return this.navigationService.createPage("woa-identification-page", {"mode": IdentificationMode.LOGIN});
    }

    async register(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("register");
        // noinspection ES6MissingAwait
        this.navigationService.dismissPage(this);
        return this.navigationService.createPage("woa-identification-page", {"mode": IdentificationMode.REGISTER});
    }

    async logout(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("logout");
        // noinspection ES6MissingAwait
        this.navigationService.dismissPage(this);
        if ((await this.identityModel.loginAsGuest()).status !== LoginStatus.SUCCESS) {
            // noinspection ES6MissingAwait
            this.sessionModel.goToEntryPage();
        }
    }

    async profile(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("profile");
        // noinspection ES6MissingAwait
        this.navigationService.dismissPage(this);
        return this.navigationService.createPage("woa-profile-edit-page");
    }

    async changePassword(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("password");
        // noinspection ES6MissingAwait
        this.navigationService.dismissPage(this);
        return this.navigationService.createPage("woa-change-password-page");
    }

    async loyaltyCards(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("loyalty-cards");
        // noinspection ES6MissingAwait
        this.navigationService.dismissPage(this);
        return this.navigationService.createPage("woa-loyalty-cards-page");
    }

    async orders(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("orders");
        // noinspection ES6MissingAwait
        this.navigationService.dismissPage(this);
        return this.navigationService.createPage("woa-customer-orders-page");
    }

    async deals(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("deals");
        // noinspection ES6MissingAwait
        this.navigationService.dismissPage(this);
        return this.navigationService.createPage("woa-deals-page");
    }

    async stores(): Promise<any> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("stores");
        // noinspection ES6MissingAwait
        this.navigationService.dismissPage(this);
        return this.orderingContextModel.viewStores();
    }

    async currentStore(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("current-store");
        // noinspection ES6MissingAwait
        this.navigationService.dismissPage(this);
        return this.orderingContextModel.viewCurrentStore();
    }

    async feedback(): Promise<void> {
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("feedback");
        // noinspection ES6MissingAwait
        this.navigationService.dismissPage(this);
        return this.navigationService.createPage("woa-feedback-page");
    }

    async rateApp(): Promise<void> {
        if (this.responsiveService.isApp) {
            if (this.responsiveService.isIos) {
                // noinspection SpellCheckingInspection
                window.open("itms-apps://itunes.apple.com/app/id" + await this.localConfigurationService.getString(Local.IOS_APP_ID));
            } else if (this.responsiveService.isAndroid) {
                window.open("market://details?id=" + await this.localConfigurationService.getString(Local.ANDROID_APP_ID));
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/nav-menu/nav-menu-page.component.ts